module.exports = __webpack_public_path__ + "img/group_3.e54bf5b9.png";